import React from 'react';
import { isLayout, Layout, RendererProps, WithClassname } from '@jsonforms/core';
import { twMerge } from '@shared/utils/twMerge';

type LayoutRendererProps = RendererProps &
  WithClassname & {
    dark?: boolean;
  };

type ExtendedLayout = Layout & {
  label?: string;
};

export const VerticalLayoutRenderer: React.FC<LayoutRendererProps> = ({
  schema,
  uischema,
  path,
  renderers,
  cells,
  dark,
}) => {
  const layout = uischema as ExtendedLayout;
  return (
    <div className="flex flex-col gap-3">
      {isLayout(uischema) && layout.label && (
        <div
          className={`border-brightGray flex gap-[8px] rounded-md border ${
            dark ? 'bg-pageBackgroundDark border-chineseBlack text-white' : 'bg-[#F6F9FF]'
          } p-[12px]`}
        >
          <div className="qc-form-label text-1824 font-medium capitalize">{layout.label}</div>
        </div>
      )}
      {isLayout(uischema) &&
        layout.elements?.map((element, index) => (
          <div
            className={twMerge(element.type === 'Group' && '-mt-1', !index && 'mt-0')}
            key={index}
          >
            {renderers
              ?.find(r => r.tester(element, schema, { rootSchema: schema, config: {} }) >= 0)
              ?.renderer({
                schema,
                uischema: element,
                path,
                renderers,
                cells,
                dark,
              })}
          </div>
        ))}
    </div>
  );
};
